/**
 * Key under which the token is saved in the local storage
 */
export const AUTH_TOKEN_LS_KEY: string = process.env.VUE_APP_AUTH_TOKEN_LS_KEY || "token";
